import cryptoJs from "crypto-js";

//获取cookie
export function getCookie(name) {
  var arr, reg = new RegExp("(^| )" + name + "==([^;]*)(;|$)");
  if (arr = document.cookie.match(reg)){
	  let key = cryptoJs.enc.Hex.parse("secretkeydgjz66a")
	  let dec = cryptoJs.AES.decrypt(cryptoJs.format.Hex.parse(arr[2]), key, {
		// vi: vi
		mode: cryptoJs.mode.ECB,
		padding: cryptoJs.pad.Pkcs7
	  })
	let decData = cryptoJs.enc.Utf8.stringify(dec)
	  
    //var bytes = CryptoJS.AES.decrypt(arr[2], "secretkeydgjz666a");
    //bytes = bytes.toString(CryptoJS.enc.Utf8)-0;
    return decData;
  }else{
    return null;
  }
}

//设置cookie,增加到vue实例方便全局调用
export function setCookie (c_name, value, expiredays) {
  //var evalue = CryptoJS.AES.encrypt(value+'',"secretkeydgjz666a").toString();
  
  let key = cryptoJs.enc.Hex.parse("secretkeydgjz66a")
  let enc = ''
  if (typeof value === 'string') {
	enc = cryptoJs.AES.encrypt(value, key, {
	  mode: cryptoJs.mode.ECB,
	  padding: cryptoJs.pad.Pkcs7
	})
  } else if (typeof value === 'object') {
	let data = JSON.stringify(value)
	enc = cryptoJs.AES.encrypt(data, key, {
	  // iv: iv
	  mode: cryptoJs.mode.ECB,
	  padding: cryptoJs.pad.Pkcs7
	})
  }
  let evalue = enc.ciphertext.toString()
  
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie = c_name + "==" + evalue + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString());
};

//删除cookie
export function delCookie (name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null)
   document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
};
